import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

/**
 * LR-711: resolve a trade's stuck BackOffice postings from its own page.
 *
 * Invalidates the whole trades key like its siblings: the action can clear a
 * posting guard, which changes both the trade's own page and its row in the
 * blotter (the stuck-posting accent), and a stale row is exactly the thing an
 * operator would act on twice.
 */
export const useReconcileBoPosting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => tradesService.reconcileBoPosting(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
